module.exports = __webpack_public_path__ + "images/29ba95c.png";